export default "__VITE_ASSET__BzLDYrXb__";